import React from "react";
import styled from "styled-components";

const Container = styled.div`
  padding: 4px 8px;
  cursor: default;
  display: inline-flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 600;
  & + & {
    margin-top: 10px;
  }
`;

interface IProps {
  color: string;
  backgroundColor: string;
  spaceLetters?: boolean;
  children: any;
}

function Tag({ color, backgroundColor, spaceLetters, children }: IProps) {
  return (
    <Container
      style={{
        color: color,
        backgroundColor: backgroundColor,
        letterSpacing: spaceLetters ? "0.4px" : "-0.01875rem",
      }}
    >
      {children}
    </Container>
  );
}

export default Tag;
